// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_section__fm4FF {
  min-height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  padding: 0rem 1rem; }

.styles_welcomeSection__ZxWD7 {
  width: 100%; }

.styles_contentWrapper__67VG9 {
  width: 100%;
  padding: 0 2rem; }

.styles_gridContainer__7bIGC {
  display: grid;
  grid-template-columns: 1fr;
  gap: 4rem;
  align-items: center;
  padding: 0 2rem; }
  @media (min-width: 48rem) {
    .styles_gridContainer__7bIGC {
      grid-template-columns: 1fr 1fr; } }

.styles_leftContent__kP6xj {
  display: flex;
  flex-direction: column;
  gap: 1.5rem; }

.styles_brandTitle__0xGDb {
  font-size: 3rem;
  font-weight: 600;
  letter-spacing: 0.05em;
  color: #808080e6;
  margin-bottom: 0.5rem; }
  @media (min-width: 48rem) {
    .styles_brandTitle__0xGDb {
      font-size: 4.5rem; } }

.styles_asterisk__i8h0Y {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 3rem;
  line-height: 1;
  color: #72ababb8;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  margin-left: 0.25rem;
  transform: translateY(-1rem);
  padding: 0.5rem; }

div:has(> div .styles_namePopover__rUdWw) {
  transform: translateY(-2.5rem) translateX(1rem); }

.styles_namePopover__rUdWw {
  padding: 0.25rem 0.75rem;
  cursor: pointer; }

.styles_namePopoverText__ji0dv {
  font-size: 1.25rem;
  color: #808080e6; }

.styles_headline__8-ytq {
  font-size: 1.875rem;
  font-weight: 600;
  line-height: 1.4;
  color: #808080e6;
  margin-bottom: 1rem;
  display: flex;
  font-style: italic; }
  @media (min-width: 48rem) {
    .styles_headline__8-ytq {
      font-size: 2.5rem; } }

.styles_headlineSuffix__3\\+34c {
  font-size: 1.25rem;
  font-weight: 300;
  color: #808080b8; }

.styles_subtext__8sePd {
  font-size: 1.5rem;
  color: #808080b8;
  line-height: 1.6;
  margin-bottom: 1.5rem; }
  @media (min-width: 48rem) {
    .styles_subtext__8sePd {
      font-size: 1.75rem; } }

.styles_ctaContainer__5M54A {
  display: flex;
  align-items: flex-start; }

button.styles_ctaButton__hTUmD {
  position: relative;
  display: inline-block;
  padding: 1rem 3rem;
  background: linear-gradient(90deg, #6366f1, #dc2626, #8b5cf6);
  color: white;
  font-weight: 500;
  font-size: 1.125rem;
  border-radius: 1rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  border: none;
  cursor: pointer;
  overflow: hidden;
  padding: 0.5rem 3rem;
  width: 100%;
  margin: 0 auto; }
  button.styles_ctaButton__hTUmD:hover {
    box-shadow: 0 0.75rem 1.5rem rgba(0, 0, 0, 0.15);
    transform: scale(1.05); }
    button.styles_ctaButton__hTUmD:hover::after {
      opacity: 1; }
  button.styles_ctaButton__hTUmD::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(90deg, #8b5cf6, #6366f1);
    opacity: 0;
    transition: opacity 0.3s ease;
    border-radius: 1rem; }

.styles_ctaText__lAw1b {
  position: relative;
  z-index: 10;
  color: white;
  font-size: 1.125rem;
  font-weight: 500; }

.styles_rightContent__qUDTi {
  display: flex;
  align-items: center;
  justify-content: center; }

.styles_illustrationWrapper__Tyr3S {
  width: 100%;
  max-width: 32rem; }

.styles_illustration__93wyT {
  width: 100%;
  height: auto;
  filter: drop-shadow(0.75rem 0.75rem 0.75rem #808080e6);
  opacity: 0.5;
  transform: scale(1.25) rotate(-3deg); }

.styles_scrollIndicator__kfgbZ {
  position: absolute;
  bottom: 2rem;
  left: 50%;
  transform: translateX(-50%);
  animation: styles_bounce__CzuAT 2s infinite; }

.styles_scrollIcon__2zRPz {
  width: 1.5rem;
  height: 1.5rem;
  color: #808080b8; }

@keyframes styles_bounce__CzuAT {
  0%,
  20%,
  53%,
  80%,
  100% {
    transform: translateX(-50%) translateY(0); }
  40%,
  43% {
    transform: translateX(-50%) translateY(-0.5rem); }
  70% {
    transform: translateX(-50%) translateY(-0.25rem); }
  90% {
    transform: translateX(-50%) translateY(-0.125rem); } }
`, "",{"version":3,"sources":["webpack://./src/modules/shelter/components/screens/LandingPage/components/WelcomeSection/styles.module.scss","webpack://./src/modules/Core/styles/variables.scss"],"names":[],"mappings":"AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB,EAAA;;AAGpB;EACE,WAAW,EAAA;;AAGb;EACE,WAAW;EACX,eAAe,EAAA;;AAGjB;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,mBAAmB;EACnB,eAAe,EAAA;EAEf;IAPF;MAQI,8BAA8B,EAAA,EAEjC;;AAED;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW,EAAA;;AAGb;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gBC1BgB;ED2BhB,qBAAqB,EAAA;EAErB;IAPF;MAQI,iBAAiB,EAAA,EAEpB;;AAED;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,gBCjBsB;EDkBtB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,oBAAoB;EACpB,4BAA4B;EAC5B,eAAe,EAAA;;AAGjB;EACE,+CAA+C,EAAA;;AAGjD;EACE,wBAAwB;EACxB,eAAe,EAAA;;AAGjB;EACE,kBAAkB;EAClB,gBC3DgB,EAAA;;AD8DlB;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,gBClEgB;EDmEhB,mBAAmB;EACnB,aAAa;EACb,kBAAkB,EAAA;EAElB;IATF;MAUI,iBAAiB,EAAA,EAEpB;;AAED;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBChFgB,EAAA;;ADmFlB;EACE,iBAAiB;EACjB,gBCrFgB;EDsFhB,gBAAgB;EAChB,qBAAqB,EAAA;EAGrB;IAPF;MAQI,kBAAkB,EAAA,EAErB;;AAED;EACE,aAAa;EACb,uBAAuB,EAAA;;AAGzB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,6DAA+D;EAE/D,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,4CAA4C;EAC5C,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;EAEX,cAAc,EAAA;EAlBhB;IAsBI,gDAAgD;IAChD,sBAAsB,EAAA;IAvB1B;MA0BM,UAAU,EAAA;EA1BhB;IA+BI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oDAAoD;IACpD,UAAU;IACV,6BAA6B;IAC7B,mBAAmB,EAAA;;AAIvB;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB,EAAA;;AAGlB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB,EAAA;;AAOzB;EACE,WAAW;EACX,gBAAgB,EAAA;;AAGlB;EACE,WAAW;EACX,YAAY;EACZ,sDAAoD;EAGpD,YAAY;EACZ,oCAAoC,EAAA;;AAItC;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,2CAA6B,EAAA;;AAG/B;EACE,aAAa;EACb,cAAc;EACd,gBC7LgB,EAAA;;ADgMlB;EAEE;;;;;IAKE,yCAAyC,EAAA;EAG3C;;IAEE,+CAA+C,EAAA;EAGjD;IACE,gDAAgD,EAAA;EAGlD;IACE,iDAAiD,EAAA,EAAA","sourcesContent":["@import \"src/modules/Core/styles/variables.scss\";\n\n.section {\n  min-height: 100vh;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  overflow: hidden;\n  padding: 0rem 1rem;\n}\n\n.welcomeSection {\n  width: 100%;\n}\n\n.contentWrapper {\n  width: 100%;\n  padding: 0 2rem;\n}\n\n.gridContainer {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 4rem;\n  align-items: center;\n  padding: 0 2rem;\n\n  @media (min-width: 48rem) {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n.leftContent {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.brandTitle {\n  font-size: 3rem;\n  font-weight: 600;\n  letter-spacing: 0.05em;\n  color: $grey90;\n  margin-bottom: 0.5rem;\n\n  @media (min-width: 48rem) {\n    font-size: 4.5rem;\n  }\n}\n\n.asterisk {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 3rem;\n  line-height: 1;\n  color: $ocean_blue72;\n  cursor: pointer;\n  user-select: none;\n  margin-left: 0.25rem;\n  transform: translateY(-1rem);\n  padding: 0.5rem;\n}\n\ndiv:has( >div  .namePopover) {\n  transform: translateY(-2.5rem) translateX(1rem);\n}\n\n.namePopover {\n  padding: 0.25rem 0.75rem;\n  cursor: pointer;\n}\n\n.namePopoverText {\n  font-size: 1.25rem;\n  color: $grey90;\n}\n\n.headline {\n  font-size: 1.875rem;\n  font-weight: 600;\n  line-height: 1.4;\n  color: $grey90;\n  margin-bottom: 1rem;\n  display: flex;\n  font-style: italic;\n\n  @media (min-width: 48rem) {\n    font-size: 2.5rem;\n  }\n}\n\n.headlineSuffix {\n  font-size: 1.25rem;\n  font-weight: 300;\n  color: $grey72;\n}\n\n.subtext {\n  font-size: 1.5rem;\n  color: $grey72;\n  line-height: 1.6;\n  margin-bottom: 1.5rem;\n  // padding: 0 0.5rem;\n\n  @media (min-width: 48rem) {\n    font-size: 1.75rem;\n  }\n}\n\n.ctaContainer {\n  display: flex;\n  align-items: flex-start;\n}\n\nbutton.ctaButton {\n  position: relative;\n  display: inline-block;\n  padding: 1rem 3rem;\n  background: linear-gradient(90deg, #6366f1, #dc2626, #8b5cf6, );\n\n  color: white;\n  font-weight: 500;\n  font-size: 1.125rem;\n  border-radius: 1rem;\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.1);\n  transition: all 0.3s ease;\n  border: none;\n  cursor: pointer;\n  overflow: hidden;\n  padding: 0.5rem 3rem;\n  width: 100%;\n  // max-width: 36rem;\n  margin: 0 auto;\n\n\n  &:hover {\n    box-shadow: 0 0.75rem 1.5rem rgba(0, 0, 0, 0.15);\n    transform: scale(1.05);\n\n    &::after {\n      opacity: 1;\n    }\n  }\n\n  &::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: linear-gradient(90deg, #8b5cf6, #6366f1);\n    opacity: 0;\n    transition: opacity 0.3s ease;\n    border-radius: 1rem;\n  }\n}\n\n.ctaText {\n  position: relative;\n  z-index: 10;\n  color: white;\n  font-size: 1.125rem;\n  font-weight: 500;\n}\n\n.rightContent {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  @media (min-width: 64rem) {\n    // justify-content: flex-end;\n  }\n}\n\n.illustrationWrapper {\n  width: 100%;\n  max-width: 32rem;\n}\n\n.illustration {\n  width: 100%;\n  height: auto;\n  filter: drop-shadow(0.75rem 0.75rem 0.75rem $grey90);\n  // filter: drop-shadow(0 0.5rem 1rem rgba(0, 0, 0, 0.1));\n  // filter: grayscale(500%);\n  opacity: 0.5;\n  transform: scale(1.25) rotate(-3deg);\n\n}\n\n.scrollIndicator {\n  position: absolute;\n  bottom: 2rem;\n  left: 50%;\n  transform: translateX(-50%);\n  animation: bounce 2s infinite;\n}\n\n.scrollIcon {\n  width: 1.5rem;\n  height: 1.5rem;\n  color: $grey72;\n}\n\n@keyframes bounce {\n\n  0%,\n  20%,\n  53%,\n  80%,\n  100% {\n    transform: translateX(-50%) translateY(0);\n  }\n\n  40%,\n  43% {\n    transform: translateX(-50%) translateY(-0.5rem);\n  }\n\n  70% {\n    transform: translateX(-50%) translateY(-0.25rem);\n  }\n\n  90% {\n    transform: translateX(-50%) translateY(-0.125rem);\n  }\n}","// @import \"src/modules/Core/styles/variables.scss\";\n\n$white90: #ffffffe6;\n$green50: #00800080;\n\n$white10: #ffffff1a;\n$white18: #ffffff2e;\n$white50: #ffffff80;\n\n$grey3:#80808008;\n$grey5: #8080800d;\n$grey7: #80808012;\n$grey10: #8080801a;\n$grey18: #8080802e;\n$grey36: #8080805c;\n$grey50: #80808080;\n$grey54: #8080808a;\n$grey72: #808080b8;\n$grey90: #808080e6;\n$grey: #808080;\n\n\n$purple100: #800080;\n$purple90: #800080e6;\n$purple72:#800080b8;\n$purple50: #80008080;\n$purple36: #8000805c;\n$purple18: #8000802e;\n\n$dark_purple: #480048;\n$deep_purple: #840000;\n\n$baby_blue: #87ceeb;\n$ui_blue: #1976d2;\n$ui_blue90: #1976d2e6;\n$ui_blue72: #1976d2b8;\n$ui_blue50: #1976d280;\n$pond_green: #72bbbb;\n$pond_green72: #72bbbbb8;\n$ocean_blue: #72abab;\n$ocean_blue90: #72ababe6;\n$ocean_blue72: #72ababb8;\n$ocean_blue50: #72abab80;\n$ocean_blue36: #72abab5c;\n$ocean_blue10: #73abab1a;\n$kermit_green: #72ab72;\n$kermit_green72: #72ab72b8;\n$somewhat_certain:#183672;\n$just_say_ok: #721446;\n$success_street: #723618;\n\n$golden: #ffd700;\n$_golden: #D4AF37;\n$bronze: #cd7f32;\n\n$bronze80: #cd7f32c2;\n$bronze50: #cd7f3280;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `styles_section__fm4FF`,
	"welcomeSection": `styles_welcomeSection__ZxWD7`,
	"contentWrapper": `styles_contentWrapper__67VG9`,
	"gridContainer": `styles_gridContainer__7bIGC`,
	"leftContent": `styles_leftContent__kP6xj`,
	"brandTitle": `styles_brandTitle__0xGDb`,
	"asterisk": `styles_asterisk__i8h0Y`,
	"namePopover": `styles_namePopover__rUdWw`,
	"namePopoverText": `styles_namePopoverText__ji0dv`,
	"headline": `styles_headline__8-ytq`,
	"headlineSuffix": `styles_headlineSuffix__3+34c`,
	"subtext": `styles_subtext__8sePd`,
	"ctaContainer": `styles_ctaContainer__5M54A`,
	"ctaButton": `styles_ctaButton__hTUmD`,
	"ctaText": `styles_ctaText__lAw1b`,
	"rightContent": `styles_rightContent__qUDTi`,
	"illustrationWrapper": `styles_illustrationWrapper__Tyr3S`,
	"illustration": `styles_illustration__93wyT`,
	"scrollIndicator": `styles_scrollIndicator__kfgbZ`,
	"bounce": `styles_bounce__CzuAT`,
	"scrollIcon": `styles_scrollIcon__2zRPz`
};
export default ___CSS_LOADER_EXPORT___;
